
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 176.1 159.3","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{staticClass:"st0",attrs:{"transform":"rotate(-13.286 52.601 94.886)","cx":"52.6","cy":"94.9","r":"3"}}),_c('path',{staticClass:"st0",attrs:{"d":"M16.1 82.5l-.6-.2.6.2z"}}),_c('ellipse',{staticClass:"st0",attrs:{"cx":"106.9","cy":"89.8","rx":"6.2","ry":"5.8"}}),_c('path',{staticClass:"st0",attrs:{"d":"M101.7 42.8h-1.2l4.9 6.1v11.4h1.5l-.1-11.6zM140.6 68.4l-19.8-5.8-2.6 3.2c5.7.5 13.5 1.7 21.2 4.2l1.2-1.6z"}}),_c('path',{attrs:{"d":"M52.6 89.6c-3.1 0-5.7 2.4-5.7 5.4 0 3 2.6 5.4 5.7 5.4s5.7-2.4 5.7-5.4c0-3.1-2.5-5.4-5.7-5.4zm0 8.3c-1.6 0-3-1.3-3-3 0-1.6 1.3-3 3-3 1.6 0 3 1.3 3 3s-1.3 3-3 3zM106.9 79.6c-6 0-10.9 4.6-10.9 10.2s4.9 10.2 10.9 10.2 10.9-4.6 10.9-10.2-4.9-10.2-10.9-10.2zm0 16c-3.4 0-6.2-2.6-6.2-5.8 0-3.2 2.8-5.8 6.2-5.8 3.4 0 6.2 2.6 6.2 5.8 0 3.2-2.8 5.8-6.2 5.8z"}}),_c('path',{attrs:{"d":"M119.1 81V100.2l45.9-.2c.1-8.8-3.1-15.1-8.3-19.9v.1l-.7-.7v-.1c-.8-.7-1.6-1.4-2.5-2 .3-2.1-.5-4.2-2.2-5.6-2.3-1.8-5.5-1.7-7.7.1-1.2-.5-2.3-.9-3.5-1.3l1.4-1.7 1.1.3 2.1-1.2-23.1-6.4-2.5.8.7.2-2.7 3.4c-2.5-.2-4.5-.3-5.7-.3H108.8V48.9l-4.8-6.1h6l-1.2-2.5H77.5l1.5 2.5h19.3l5.1 6 .1 11.5h-19v-7.7l-30.2 5.9v-5.3h-4.4v-5.5s.2-3-4.5-3l-.9 1.6s3.6-.3 3.8 3.3v3.6h-4.6v4.6l-21.6 6.4-6.7 18.1.5.2-.6-.2 3.9 8.7 26 5.4v-8.2H56v1.5h3.5v8.9h35.7V82.7H97l5.5-4.4H119.2V81zm-13.7-20.7V48.9l-4.8-6.1h1.1l5.1 6 .1 11.5h-1.5zm12.7 5.6l2.6-3.2 19.8 5.8-1.3 1.7c-7.6-2.6-15.4-3.8-21.1-4.3z"}})])
          )
        }
      }
    